{
  "$schema": "http://iglucentral.com/schemas/com.snowplowanalytics.self-desc/schema/jsonschema/1-0-0#",
  "description": "Schema for a IDE and IDE extension version informations",
  "self": {
    "vendor": "com.gitlab",
    "name": "ide_extension_version",
    "version": "1-1-0",
    "format": "jsonschema"
  },
  "type": "object",
  "additionalProperties": false,
  "required": [
    "ide_name",
    "ide_version",
    "ide_vendor",
    "extension_name",
    "extension_version",
    "language_server_version"
  ],
  "properties": {
    "ide_name": {
      "description": "Name of the IDE, e.g. RubyMibe",
      "type": ["string", "null"],
      "maxLength": 32
    },
    "ide_version": {
      "description": "Version number of the IDE, e.g. 1.81.1",
      "type": ["string", "null"],
      "maxLength": 32
    },
    "ide_vendor": {
      "description": "Name of the IDEs vendor, e.g. Microsoft",
      "type": ["string", "null"],
      "maxLength": 32
    },
    "extension_name": {
      "description": "Name of the IDE extension, e.g. GitLab Workflow",
      "type": ["string", "null"],
      "maxLength": 32
    },
    "extension_version": {
      "description": "Version number of the IDE extension, e.g. 3.81.1",
      "type": ["string", "null"],
      "maxLength": 32
    },
    "language_server_version": {
      "description": "Version number of the Language Server, e.g. 3.9.0",
      "type": ["string", "null"],
      "maxLength": 32
    }
  }
}
